import React from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BookingService from 'services/BookingService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class CSATResponseModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.id = opts.id;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        const csatResponse = await BookingService.getCSATResponse(this.id);
        this.setState({
            csatResponse,
            isLoading: false
        });
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>

            <Modal show className="csat-response-modal">
                {this.renderInner()}
            </Modal>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            csatResponse
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }
        
        return (<>
            <Modal.Body>

                <Row className="mb-3">

                    <Col md="3">

                        <Form.Group className="">
                            <Form.Label>Overall</Form.Label>
                            <p className="form-control-plaintext">
                                {csatResponse.overallScore}
                            </p>
                        </Form.Group>

                    </Col>

                    <Col md="3">

                        <Form.Group className="">
                            <Form.Label>Instructor</Form.Label>
                            <p className="form-control-plaintext">
                                {csatResponse.instructorScore}
                            </p>
                        </Form.Group>

                    </Col>

                    <Col md="3">

                        <Form.Group className="">
                            <Form.Label>Environment</Form.Label>
                            <p className="form-control-plaintext">
                                {csatResponse.environmentScore}
                            </p>
                        </Form.Group>

                    </Col>

                    <Col md="3">

                        <Form.Group className="">
                            <Form.Label>Courseware</Form.Label>
                            <p className="form-control-plaintext">
                                {csatResponse.coursewareScore}
                            </p>
                        </Form.Group>

                    </Col>

                </Row>

                <Form.Group className="">
                    <Form.Label>Feedback from the class participants ("Recommended changes" and "What was liked"):</Form.Label>
                    <ul className="csat-response-items">
                        {csatResponse.items.map((item, index) =>
                            <li key={index}>
                                {item.value}
                            </li>
                        )}
                    </ul>
                </Form.Group>
                    
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-primary" onClick={() => this.close()}>
                    Close
                </button>
            </Modal.Footer>
        </>);
    }

}

export default CSATResponseModal;